export enum HiddenFeatures {
  EInvoice = 'EINVOICE',
  ValidateInvoice = 'VALIDATE_INVOICE',
}

const envService = {
  isFeatureHidden: (feature: HiddenFeatures): boolean => {
    return (
      !!process.env.REACT_APP_HIDDEN_FEATURE &&
      process.env.REACT_APP_HIDDEN_FEATURE.split(',')
        .map((f: string) => f.trim().toUpperCase())
        .includes(feature)
    );
  },
};

export default envService;
